// color
export const Color = {
  WHITE: '#fff', // default background color
  GRAY100: '#ccc', // border or shadow
  GRAY200: '#333', // sub
  BLACK: '#000', // default font color
  BLUE100: '#0071e3', // highlight or font hover
  BLUE200: '#005dba' // blue color hover
}

// font
export const Text = {
  SM: '14px', // footer, sub text
  MD: '20px' // title
}